import Receitas from '@/views/public/receitas_despesas/receitas'
import ReceitasDetalhes from '@/views/public/receitas_despesas/receitas/Detalhes'
import Despesas from '@/views/public/receitas_despesas/despesas'
import DetalheGrupo from '@/views/public/receitas_despesas/despesas/DetalheGrupoDespesa'
import { DEFAULT_TITLE } from '../const'

export const receitasDespesas = [
  {
    name: 'receitas_despesas',
    path: '/receitas_despesas',
    component: () => import('@/views/public/receitas_despesas'),
    meta: {
      title: `${DEFAULT_TITLE} | Receitas e Despesas`
    }
  },
  {
    name: 'receitas',
    path: '/receitas',
    component: Receitas,
    meta: {
      title: `${DEFAULT_TITLE} | Receitas`
    }
  },
  {
    name: 'receitas_detalhes',
    path: '/receitas/detalhes/:id',
    component: ReceitasDetalhes,
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes de receitas`
    }
  },
  {
    name: 'despesas',
    path: '/despesas',
    component: Despesas,
    meta: {
      title: `${DEFAULT_TITLE} | Despesas`
    }
  },
  {
    name: 'detalhe_grupo_despesa',
    path: '/despesas/grupo/:descricao/:operacao/detalhes',
    component: DetalheGrupo,
    meta: {
      title: `${DEFAULT_TITLE} | Despesas por grupo`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/receitasDespesas.js